export default __webpack_public_path__ + "static/media/12-32-24 3.8329bf73.jpg";